import firebase from 'firebase';
import Config from '../firebase-configs';
console.log(Config);
firebase.initializeApp(Config);
firebase.analytics();
export default firebase;
